import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Users } from 'lucide-react';
import { useEffectiveAccess } from '../../agenticsaas/contexts/EffectiveAccessContext';

/**
 * Shows trial/seat/upgrade context from effective-access subscription payload.
 */
export default function SubscriptionBanner() {
  const { subscription, loading } = useEffectiveAccess();
  if (loading || !subscription?.plan_name) return null;

  const { status, plan_display_name, seats_used, seats_limit, trial_ends_at, recommend_upgrade, locations_used, locations_limit } = subscription;
  const seatPct =
    seats_limit && seats_limit > 0 ? Math.round((100 * (seats_used || 0)) / seats_limit) : null;
  const locationPct =
    locations_limit && locations_limit > 0 ? Math.round((100 * (locations_used || 0)) / locations_limit) : null;
  const seatsNearLimit = seatPct != null && seatPct >= 90;
  const locationsNearLimit = locationPct != null && locationPct >= 90;

  if (status !== 'in_trial' && !seatsNearLimit && !locationsNearLimit && !recommend_upgrade) {
    return null;
  }

  let message = null;
  if (status === 'in_trial' && trial_ends_at) {
    const end = new Date(trial_ends_at);
    const daysLeft = Math.max(0, Math.ceil((end - Date.now()) / (1000 * 60 * 60 * 24)));
    message = `${plan_display_name || 'Trial'} ends in ${daysLeft} day${daysLeft === 1 ? '' : 's'}.`;
  } else if (seatsNearLimit) {
    message = `Seat usage ${seats_used}/${seats_limit} on ${plan_display_name || 'your plan'}.`;
  } else if (locationsNearLimit) {
    message = `Location usage ${locations_used}/${locations_limit} on ${plan_display_name || 'your plan'}.`;
  } else if (recommend_upgrade) {
    message = `Usage limits approaching on ${plan_display_name || 'your plan'}.`;
  }

  if (!message) return null;

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 flex flex-wrap items-center justify-between gap-2 text-sm text-amber-900">
      <div className="flex items-center gap-2">
        {seatsNearLimit ? <Users className="h-4 w-4 shrink-0" aria-hidden /> : <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden />}
        <span>{message}</span>
      </div>
      <Link to="/subscription" className="font-medium text-amber-900 underline hover:text-amber-950">
        View plans
      </Link>
    </div>
  );
}
